import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { Trans } from '@lingui/macro';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useAtomValue } from 'jotai';
import { pathnameUrlLanguageAtom, ValidSections, pathnameUrlNewsArticleOrSection } from '../../../../../../../../history';
import { Space } from '../../../../../../../Space';
import { useRobotNoIndex } from '../../../../../../../useRobotNoIndex';

export const ArticleNotFound = () => {
  useRobotNoIndex();
  const article = useAtomValue(pathnameUrlNewsArticleOrSection);
  const locale = useAtomValue(pathnameUrlLanguageAtom);
  return (
    <ouiDom.HeadingSection.HeadingSection
      name="ArticleNotFound"
      index={0}
      container={ouiStyle.Constants.Container.xl}
      paddingHorizontal="simple"
    >
      <TopModel name="HeadingSectionTitleContent-ArticleNotFound">
        <Trans>
          Article non trouvé
        </Trans>
      </TopModel>
      <ouiDom.P.P
        color={ouiStyle.Constants.Colors.greyDarkest}
      >
        <Trans>
          L'article
          <Space />
          «
          {article}
          »
          <Space />
          {' '}
          n'existe pas ou plus.
        </Trans>
      </ouiDom.P.P>
      <ouiDom.P.P
        color={ouiStyle.Constants.Colors.greyDarkest}
      >
        <Trans>
          Souhaitez-vous retourner à la
          <Space />
          <ouiDom.A.A
            to={`/${locale}/${ValidSections.NEWS}`}
          >
            page d'accueil
          </ouiDom.A.A>
          ?
        </Trans>
      </ouiDom.P.P>
    </ouiDom.HeadingSection.HeadingSection>
  );
};
